// src/components/MergeInventoryItem.jsx
import React, {useContext} from 'react';
import {Card, Tooltip} from 'antd';
import {AuthContext} from "../../contexts/authContext";
import {useItemKrTextData} from "../../../features/probability/useItemData";
import IsLoading from "../IsLoading";
import ErrorPage from "../ErrorPage";
import {useMergeBlockImageMap, resolveMergeBlockImageUrl} from "../../hooks/useMergeBlockImageMap";


const MergeInventoryItem = React.memo(({item, mergeMainData, isTopItem}) => {
    const { currentUser } = useContext(AuthContext);
    const {data: krItemTextData, isLoading, error} = useItemKrTextData();
    const {data: imageMap} = useMergeBlockImageMap();
    const blockIndex = item?.mIndex || item?.blockIndex;
    const count = item?.mCount || item?.productCount;
    const type = item?.mItemType || 0;

    if (isLoading) return <IsLoading />;
    if (error) return <ErrorPage error={error} />;

    let blockDetails = {};
    if (type === 10) {
        blockDetails = mergeMainData[`${blockIndex}_10`];
    } else {
        blockDetails = mergeMainData[blockIndex];
    }
    const imageUrl = resolveMergeBlockImageUrl(blockDetails?.resourcePath, imageMap);
    const blockName = krItemTextData[currentUser.target].find(e => e.index === blockDetails?.blockNameLIdx)?.name|| `Block ${blockIndex}`;

    return (
        <Card
            size="small"
            style={{
                width: '80px', // 작은 아이템 크기
                height: '80px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '8px',
                border: `2px solid ${isTopItem ? '#ff7875' : '#d9d9d9'}`, // LIFO의 맨 앞 아이템 강조
                backgroundColor: '#fff',
                boxShadow: isTopItem ? '0 4px 8px rgba(255,120,117,0.3)' : '0 1px 3px rgba(0,0,0,0.1)',
                flexShrink: 0, // 아이템이 줄어들지 않도록
                position: 'relative', // Count 배지 위치 조정을 위해
                marginBottom: isTopItem ? '10px' : '0px', // 맨 위 아이템과 다음 아이템 간 간격
            }}
        >
            <Tooltip title={blockName}>
                <img
                    src={imageUrl}
                    alt={blockName}
                    style={{width: '85%', height: '85%', objectFit: 'contain', borderRadius: '4px'}}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '';
                    }}
                />
            </Tooltip>
            {count > 1 && (
                <div style={{
                    position: 'absolute',
                    bottom: '2px',
                    right: '2px',
                    backgroundColor: '#52c41a',
                    color: 'white',
                    fontSize: '0.7em',
                    padding: '1px 4px',
                    borderRadius: '8px',
                    fontWeight: 'bold',
                }}>
                    {count}
                </div>
            )}
        </Card>
    );
});

export default MergeInventoryItem;